<template>
  <div class="page-wrap">
    <div class="header-area">
      <!--<Top />-->
    </div>
    <div class="slide-specified-index">
      <div class="banner-wrapper">
        <div class="slide-specified-wrapper" v-if="pageData" ref="slide">
          <div class="slide-specified-content"
               :style="{'visibility': isShow? 'visible': 'hidden'}">
            <div v-for="(item, num) in pageData"
                 class="slide-page"
                 :style="{backgroundImage:`url(${item.pic})`}" :key="num">
              <div class="page-tit">
                <!--<strong>{{item.title}}</strong>-->
                <strong>产业布局</strong>
                <span>INDUSTRIAL LAYOUT</span>
              </div>
              <div class="page-con">
                <h4 class="tit">{{item.title}}</h4>
                <p>{{item.message}}</p>
                <a class="btn" href="#/chan/first">了解更多→</a>
              </div>
            </div>
          </div>
        </div>
        <div class="dots-wrapper">
        <span
                class="dot"
                v-for="(item, num) in pageData"
                :key="num"
                :class="{'active': currentPageIndex === num}"></span>
        </div>
      </div>
    </div>
  </div>
  <!--</div>-->
</template>

<script>
  // import Top from "../components/Top";
  import BScroll from '@better-scroll/core'
  import Slide from '@better-scroll/slide'
  import {getWapFirstPic} from '@/api/index';

  BScroll.use(Slide);
  export default {
    components:{
      // Top
    },
    data() {
      return {
        slideCreated: false,
        nums: 4,
        currentPageIndex: 0,
        pageData: null,
        isShow: false,
      }
    },
    created(){
      getWapFirstPic({}).then(res=>{
        this.pageData = res.data;
        setTimeout(()=>{
          this.isShow = true;
          this.init();
          this.slideCreated = true;
        }, 500);
      })
    },

    mounted() {
      // this.$nextTick(()=>{
      //   setTimeout(()=>{
      //     this.init();
      //     this.slideCreated = true
      //   }, 1000);
      // })
    },
    beforeDestroy() {
      // this.slide.destroy()
    },
    methods: {
      init() {
        this.slide = new BScroll(this.$refs.slide, {
          scrollX: true,
          scrollY: false,
          slide: true,
          momentum: false,
          bounce: false,
          probeType: 3,
          active: 1
        })
        // this.slide.on('scrollEnd', this._onScrollEnd)

        this.slide.on('slideWillChange', (page) => {
          this.currentPageIndex = page.pageX
        });
      },
      _onScrollEnd () {
        // console.log('CurrentPage => ', this.slide.getCurrentPage())
      },
      nextPage() {
        this.slide.next()
      },
      prePage() {
        this.slide.prev()
      }
    }
  }
</script>

<style lang="scss">
  .page-wrap{
    height: 93vh;
    display: flex;
    flex-direction: column;
  }
  .header-area{
    flex-shrink: 0;
  }


  .slide-specified-index {
    flex-grow: 1;
    height: 1px;
    .banner-wrapper {
      position: relative;
      height: 100%;
      display: flex;
    }
    .slide-specified-wrapper {
      min-height: 1px;
      overflow: hidden;
    }
    .slide-specified-content {
      display: flex;
      height: 100%;
    }
    .slide-page {
      display: flex;
      width: 100%;
      height: 100%;
      flex-direction: column;
      background-size:100% 100%;
    }
    .slide-page.page1 {
      background-color: #ea7272;
    }
    .slide-page.page2 {
      background-color: #dda789;
    }
    .slide-page.page3 {
      background-color: #c3d899;
    }
    .slide-page.page4 {
      background-color: #f2d4a7;
    }
    .page-tit{
      padding: 20px;
      display: flex;
      align-items: flex-end;
      strong{
        font-size: 5vw;
        position: relative;
        color: #fff;
        &:after{
          content: '';
          position: absolute;
          height: 0.5vw;
          border-radius: 1vw;
          background-color: #d7000f;
          left: 0;
          top: 100%;
          margin-top: 2vw;
          width: 120%;
        }
      }
      span{
        font-weight: 300;
        color:#fff;
        margin-left: 3vw;
        font-size: 4vw;
      }
    }
    .dots-wrapper {
      bottom: 20px;
      left: 50%;
      position: absolute;
      transform: translateX(-50%);
      .dot {
        border-color: #fff;
        border-style: solid;
        border-width: 2px;
        border-radius: 50%;
        display: inline-block;
        height: 8px;
        margin: 0 4px;
        width: 8px;
      }
      .dot.active {
        background-color: #fff;
      }
    }
    .page-con{
      flex-grow: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      .tit{
        font-size: 5vw;
        color:#fff;
      }
      p{
        margin: 18vw 5vw 20vw;
        color:#fff;
        font-size: 3.6vw;
        line-height: 4.7vw;
      }
      .btn{
        width: 30vw;
        height: 4vh;
        background-color:#d7000f;
        color:#fff;
        display: flex;
        border-radius:1vw;
        justify-content: center;
        align-items: center;
        font-size: 3.5vw;
      }
    }

  }
</style>